import { Route } from '@angular/router';

export const microLoanRoute: Route = {
  path: 'microloan',
  data: { title: 'Micro Loan' },
  loadChildren : () => import('../../app/modules/micro-loan/micro-loan.module').then(m => m.MicroLoanModule)
};